import ListItemTitleTagDescription from './list-item-title-tag-description';

export default ListItemTitleTagDescription;
